import { v4 as uuidv4 } from 'uuid';
import { MarketingEventsPluginView } from './MarketingEventsPluginView';
import i18n from '../../../i18n';
import { MarketingEventsGridPluginSettings } from './MarketingEventsGridPluginSettings';

export const MarketingEventsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingEvents"),
        view: {
            content: MarketingEventsGridPluginSettings
                ? <MarketingEventsPluginView gridId={uuidv4()} plugin={MarketingEventsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
